import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  banners: [],
  loading: false,
  error: null,
};
const BASE_URL = "https://api.aweioio.com/api/banners"; // Updated to /banners

// Fetch banners for a business
export const fetchBanners = createAsyncThunk(
  "banners/fetchBanners",
  async (businessId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `https://api.aweioio.com/api/banners/${businessId}` // Updated to /banners
      );
      return response.data.banners; // Return the banners
    } catch (error) {
      console.error(
        "Error fetching banners:",
        error.response?.data || error.message
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Create a banner
export const createBanner = createAsyncThunk(
  "banners/createBanner",
  async ({ title, description, businessId }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "https://api.aweioio.com/api/banners", // Updated to /banners
        {
          title,
          description,
          businessId,
        }
      );
      return response.data.banner; // Return the created banner
    } catch (error) {
      console.error(
        "Error creating banner:",
        error.response?.data || error.message
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateBanner = createAsyncThunk(
  "banners/update",
  async ({ bannerId, title, description }, { rejectWithValue }) => {
    try {
      const res = await axios.put(`${BASE_URL}/${bannerId}`, { title, description });
      return res.data.banner;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteBanner = createAsyncThunk(
  "banners/delete",
  async ({ bannerId, businessId }, { rejectWithValue }) => {
    console.log(bannerId, "bannerId")
    try {
      await axios.delete(`${BASE_URL}/${bannerId}/${businessId}`); // Updated to /banners
      return bannerId;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const bannersSlice = createSlice({
  name: "banners",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBanners.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBanners.fulfilled, (state, action) => {
        state.loading = false;
        state.banners = action.payload;
      })
      .addCase(fetchBanners.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createBanner.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createBanner.fulfilled, (state, action) => {
        state.loading = false;
        state.banners.push(action.payload); // Add the new banner
      })
      .addCase(createBanner.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateBanner.fulfilled, (state, action) => {
        const index = state.banners.findIndex(b => b._id === action.payload._id);
        if (index !== -1) state.banners[index] = action.payload;
      })
      .addCase(deleteBanner.fulfilled, (state, action) => {
        state.banners = state.banners.filter(b => b._id !== action.payload);
      });
  },
});

export default bannersSlice.reducer;
